import { Tag } from 'antd';
import React from 'react';

const statusToColorMap = {
  BAP: 'volcano',
  CANCEL: 'geekblue',
  INIT: 'blue',
  PAID: 'blue',
  VALID: 'green',
  REJECT: 'error',
};

export type SIStatusTagProps = {
  status: string;
  statuslabel: string;
};

const SIStatusTag = ({ status, statuslabel }: SIStatusTagProps) => {
  const statusUpperCase = status?.toUpperCase();
  //@ts-ignore
  return <Tag color={statusToColorMap[statusUpperCase]}>{statuslabel}</Tag>;
};

export default SIStatusTag;
